import gql from "graphql-tag";

export const MY_LEAVES_BY_CONTRACT_SUBSCRIPTION = gql`
  subscription leavesSubscription {
    leavesSubscription
  }
`;
